<template>
  <footer class="footer">
    <div class="container">
      <div class="footer-bottom">
        <p>&copy; 2025 弋沐. 保留所有权利.</p>
        <p><a href="http://beian.miit.gov.cn/" target="_blank">浙ICP备19033301号-4</a></p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'FooterComponent'
}
</script>

<style scoped>
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* 页脚 */
.footer {
  background-color: #333;
  color: white;
  padding: 50px 0 20px;
  margin-top: auto;
}

.footer-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  flex-wrap: wrap;
  gap: 30px;
}

.footer-brand {
  display: flex;
  align-items: center;
  font-size: 24px;
  font-weight: 700;
}

.footer-brand i {
  margin-right: 10px;
  color: #667eea;
}

.footer-links {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
}

.footer-links a {
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  transition: color 0.3s;
}

.footer-links a:hover {
  color: white;
}

.footer-social {
  display: flex;
  gap: 15px;
}

.footer-social a {
  color: rgba(255, 255, 255, 0.8);
  font-size: 20px;
  transition: color 0.3s;
}

.footer-social a:hover {
  color: white;
}

.footer-bottom {
  text-align: center;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding-top: 20px;
  color: rgba(255, 255, 255, 0.6);
  font-size: 14px;
}

.footer-bottom a {
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
}

.footer-bottom a:hover {
  color: white;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .footer-content {
    justify-content: center;
    text-align: center;
  }
  
  .footer-links {
    justify-content: center;
  }
}
</style>